import React from 'react';
import MultipleRemoveFeaturedCoupons
  from '@/Pages/Categories/Assets/MultipleFeaturedCouponsAction/MultipleRemoveFeaturedCoupons';

const MultipleFeaturedCouponsAction = ({checked}) => {
  return (
    <div className='flex'>
      <MultipleRemoveFeaturedCoupons checked={checked}/>
    </div>
  );
};

export default MultipleFeaturedCouponsAction;
